import * as React from 'react';
import { useCallback } from 'react';
import { Box, FormControl, Grid2 as Grid, InputLabel, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material';

import 'react-phone-number-input/style.css'
import PhoneInput, { DefaultInputComponentProps, Value as PhoneValue, Props } from 'react-phone-number-input';

const StyledPhoneInput = (props: Props<DefaultInputComponentProps>): JSX.Element => (
    <Box
        component='fieldset'
        sx={{
            borderRadius: '4px',
            borderWidth: '1px',
            borderColor: (theme) => theme.palette.divider.slice(0, -4) + '.23)',
            padding: '16px',
            boxSizing: 'border-box',
            '&:hover': {
                borderColor: (theme) => theme.palette.divider.slice(0, -4) + '.87)',
            },
            '.PhoneInput input': {
                background: 'none',
                border: 0,
                color: (theme) => theme.palette.text.primary,
                fontSize: '1rem',
                height: '1.4375em',
                outline: 'none'
            }
        }}>
        <PhoneInput {...props} />
    </Box>

)


export interface ContactProps {
    firstName: string;
    lastName: string;
    serviceType: string;
    orgName: string;
    planName?: string;
    phone?: PhoneValue;
}
export interface ContactFormProps {
    contact: ContactProps;
    disabled?: boolean;
    onChange: (contact: ContactProps) => void;
}

const ContactForm = ({ contact, disabled, onChange }: ContactFormProps) => {

    const onTextChange = useCallback((event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        if (event.target.name === 'first-name') {
            onChange({ ...contact, firstName: event.target.value });
        }
        if (event.target.name === 'last-name') {
            onChange({ ...contact, lastName: event.target.value });
        }
        if (event.target.name === 'org-name') {
            onChange({ ...contact, orgName: event.target.value });
        }
        if (event.target.name === 'plan-name') {
            onChange({ ...contact, planName: event.target.value });
        }
    }, [contact, onChange]);

    const onSelectChange = useCallback((event: SelectChangeEvent<string>, child: React.ReactNode) => {
        if (event.target.name === 'service-type') {
            onChange({ ...contact, serviceType: event.target.value });
        }
    }, [contact, onChange]);

    const onPhoneChange = useCallback((value?: PhoneValue | undefined) => {
        onChange({ ...contact, phone: value });
    }, [contact, onChange]);

    return (
        <Grid container spacing={2} columns={{xs: 6, sm: 12}}>
            <Grid size={6}>
            <TextField name='first-name' label='First Name' value={contact.firstName} onChange={onTextChange} disabled={disabled} fullWidth />
            </Grid>
            <Grid size={6}>
            <TextField name='last-name' label='Last Name' value={contact.lastName} onChange={onTextChange} disabled={disabled} fullWidth />
            </Grid>
            <Grid size={6}>
            <TextField name='org-name' label='Company Name' value={contact.orgName} onChange={onTextChange} disabled={disabled} fullWidth />
            </Grid>
            <Grid size={6}>
            <TextField name='plan-name' label='Plan Name' value={contact.planName || ''} onChange={onTextChange} disabled={disabled} fullWidth />
            </Grid>
            <Grid size={6}>
            <FormControl fullWidth>
                <InputLabel id='service-label'>Type of Service</InputLabel>
                <Select name='service-type' labelId='service-label' value={contact.serviceType} onChange={onSelectChange} disabled fullWidth >
                    <MenuItem value='transitionOfCare'>Transition of Care</MenuItem>
                    <MenuItem value='gapsInCare'>Gaps in Care</MenuItem>
                    <MenuItem value='annualWellness'>Annual Welness visit</MenuItem>
                </Select>
            </FormControl>
            </Grid>
            <Grid size={6}>
            <StyledPhoneInput
                placeholder="Enter phone number"
                value={contact.phone}
                onChange={onPhoneChange}
                defaultCountry='US'
                disabled={disabled}
            />
            </Grid>
        </Grid>
    );
}

export default ContactForm;